export default "__VITE_ASSET__AGnlkro4__"